<template>
  <PostLoginHeader @click="openDropdown = null" :app_token="app_token" />
  <Modal v-if="popup !== null" :size="'medium'">
    <template v-slot:header>
      <div class="d-flex justify-content-between align-items-center w-100">
        <div style="width: 57px"></div>
        <h4 class="section-header fw-bold">
          {{ popup == "New Case" ? "Create Case" : popup }}
        </h4>
        <button class="btn btn-gray btn-xl" @click="popup = null">
          <i class="fa fa-close"></i>
        </button>
      </div>
    </template>
    <template v-slot:body>
      <NewCase
        class="case-popup"
        v-if="popup == 'New Case'"
        @closeNewCaseEvent="closeNewCase"
        :app_token="app_token"
        :newCaseFlag="true"
        :rowCount="rows.length"
        :organizationSettings="organizationSettings"
        @savedNewCaseEvent="savedNewCase"
      />
      <NewCase
        class="case-popup"
        v-if="popup == 'Edit Case'"
        @closeNewCaseEvent="closeNewCase"
        :app_token="app_token"
        :newCaseFlag="false"
        :currentCase="selectedCase"
        :organizationSettings="organizationSettings"
        @savedNewCaseEvent="savedNewCase"
      />
      <Scenarios
        v-else-if="popup == 'Manage Scenarios'"
        :scenarios="caseStore.selectedCaseScenarios"
        :selectedCase="selectedCase"
        :charges="charges"
        :caseProbationFactors="CaseProbationFactors"
        :probationFactors="ProbationFactors"
        :CaseProbationLimitations="CaseProbationLimitations"
      />
    </template>

    <!-- <template v-slot:footer>
    </template> -->
  </Modal>
  <Modal v-if="deleteCaseModal">
    <template v-slot:header>
      <div class="d-flex justify-content-between w-100">
        <div></div>
        <h1 class="section-header fw-bold" style="text-align: center">Delete Case</h1>
        <button
          class="btn btn-gray btn-xl"
          @click="
            deleteCaseModal = false;
            caseToDelete = null;
          "
        >
          <i class="fa fa-close"></i>
        </button>
      </div>
    </template>
    <template v-slot:body>
      <p class="fs-5">Are you sure you want to delete this case and all associated charges?</p>
      <p class="fs-5 fw-bold my-3">
        {{ caseToDelete?.DefendantFirstName }} {{ caseToDelete?.DefendantLastName }}
        <span v-if="caseToDelete?.CaseNumber && caseToDelete.CaseNumber.trim() !== ''">
          ({{ caseToDelete?.CaseNumber }})
        </span>
      </p>
      <div class="d-flex">
        <div>
          <button @click="deleteCase(caseToDelete?.Id)" class="btn btn-primary btn-xl mr-3">Delete</button>
        </div>
        <div>
          <button
            class="btn btn-outline btn-xl"
            @click="
              deleteCaseModal = false;
              caseToDelete = null;
            "
          >
            Cancel
          </button>
        </div>
      </div>
    </template>
  </Modal>

  <AdPopUpModal
    v-if="showAdPopUpModal"
    :vhtmlContent="vhtmlContent"
    :imageUrl="imageUrl"
    :adCode="adCode"
    :adType="adType"
    @close="deleteAdPopUp"
  >
  </AdPopUpModal>

  <!-- <Modal v-if="showAdPopUpModal">
    <template v-slot:header>
      <div class="d-flex justify-content-between align-items-center w-100">
        <div></div>
        <h4 class="fs-3 fw-bold ta-c w-100">{{ adCode }}</h4>
        <button class="btn btn-gray btn-xl" @click="showAdPopUpModal = false">
          <i @click="turnOffShowAdForUser" class="fa fa-close"></i>
        </button>
      </div>
    </template>

    <template v-slot:body>
      <div class="ad-popup-content px-4 py-3">
        <div v-if="imageUrl" class="mb-4">
          <img 
            :src="imageUrl" 
            alt="Ad Image" 
            class="w-full h-auto rounded shadow-sm"
          />
        </div>
        <div v-html="vhtmlContent" class="text-gray-700 leading-relaxed"></div>
      </div>
    </template>
  </Modal> -->

  <div class="mx-auto w-100" @click="openDropdown = null">
    <main>
      <!-- <div v-if="!showCaseList">

      <CaseDetails ref="caseDetailsRef" :key="selectedCase.Id" v-if="showCaseDetails" :app_token="app_token" :selectedCase="selectedCase"  :launchCrimesLookup="launchCrimesLookup"></CaseDetails>
    </div> -->

      <div class="modal-tom" v-if="this.firstLoginMessage === 0">
        <div class="modal-content">
          <div class="d-flex flex-column">
            <div class="card-body">
              <div class="card-header bg-transparent border-0 text-center">
                <h1 class="fs-3 fw-bold mb-2">Welcome to CrimeTime</h1>
              </div>

              <div class="card-body d-flex flex-column">
                <p class="my-3 fs-5 text-center">
                  We're excited to have you on board! CrimeTime is designed to simplify and streamline the complex process of
                  criminal sentencing. Below is a quick overview of our key products:
                </p>

                <table class="table table-borderless my-3">
                  <tbody>
                    <tr class="my-2">
                      <td class="fs-5 fw-bold">Cases:</td>
                      <td class="fs-5 fw-normal">
                        Search by statute number and offense date, select from our database of 7,000+ crimes, and add crimes,
                        enhancements, probation allegations, and more.
                      </td>
                    </tr>
                    <tr class="my-2">
                      <td class="fs-5 fw-bold">Single Search:</td>
                      <td class="fs-5 fw-normal">
                        Quickly locate information, and find crimes based on your search criteria, and view relevant
                        information for qualifying offenses.
                      </td>
                    </tr>
                    <tr class="my-2">
                      <td class="fs-5 fw-bold">Custody Credit & Release Date Calculator:</td>
                      <td class="fs-5 fw-normal">
                        Calculate actual time & conduct credits, specify unlimited incarceration periods, and estimate
                        release dates.
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="d-flex w-100 justify-content-evenly">
                  <button class="btn btn-primary btn-xl" @click="updateFirstLoginMessage">Get Started</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="d-flex justify-content-evenly tab-col" @click="openDropdown = null">
        <div
          class="m-0 col-12 p-0 d-flex flex-column flex-lg-row overflow-auto scrollbar"
          style="height: 90vh; overflow: visible"
        >
          <div class="col-12 col-lg-2 overflow-auto p-0">
            <div class="card p-0 m-0 border-right h-100">
              <div class="card-header fs-6 fw-bold d-flex align-items-center">
                <p class="m-0 section-header pl-5 pt-3">Controls</p>
              </div>
              <div class="d-flex flex-column card-body px-5">
                <label for="search" class="fs-5 fw-bold">Search Cases</label>
                <input
                  type="text"
                  v-model="search"
                  label="Search"
                  class="form-control form-control-lg fs-5 w-100 mb-5"
                  placeholder="Search by Last Name or Case Number"
                />
                <div>
                  <button
                    class="btn btn-primary btn-xl mb-2 d-flex justify-content-between align-items-center"
                    @click="popup = 'New Case'"
                    v-if="casestatus?.length !== 0 && rows?.length !== 0"
                  >
                    <span class="fs-5">Add New Case</span>
                    <i class="fa fa-plus ml-3"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-10 h-100 p-0 scrollbar" @click="openDropdown = null">
            <div class="card p-0 h-100 m-0 overflow-auto">
              <div class="card-header fs-6 fw-bold">
                <p class="m-0 section-header pl-5 fw-bold py-3">Case List</p>

                <!-- County &gt; Agency &gt; Branch &gt; Team &gt; User :
            {{ app_attr.LastName }}, {{ app_attr.FirstName }} -->
              </div>
              <div class="card-body m-0" @click="openDropdown = null">
                <div class="table-striped table-hover my-0 table-responsive bg-light p-0" style="width: 100%">
                  <table class="table mb-0 shadow-sm table-sm w-100 border-0 border-bottom border-right" @click.stop>
                    <thead class="sticky-top">
                      <tr class="fw-bold fs-5 bg-primary" @click="openDropdown = null">
                        <!-- <th v-for="col in columns" :key="col.id">{{ col.text }}</th>
                    <th>&nbsp;</th> -->
                        <!-- <th style="width: 1px"> Photo </th> -->

                        <th class="fw-bold fs-5 pl-5">Last Name <i class="fa fa-sort" @click="sort('LastName')"> </i></th>
                        <th class="fw-bold fs-5">First Name <i class="fa fa-sort" @click="sort('FirstName')"> </i></th>
                        <th class="fw-bold fs-5">
                          Middle Name
                          <i class="fa fa-sort" @click="sort('MiddleName')"> </i>
                        </th>
                        <th class="fw-bold fs-5">Case # <i class="fa fa-sort" @click="sort('Case#')"> </i></th>
                        <!-- <th class=" fw-bold fs-5">Primary Charge</th> -->
                        <!-- <th class=" fw-bold fs-5">Description</th> -->
                        <th class="fw-bold fs-5">Created <i class="fa fa-sort" @click="sort('Created')"> </i></th>
                        <th class="fw-bold fs-5">Status <i class="fa fa-sort" @click="sort('Status')"> </i></th>
                        <th class="fw-bold fs-5" style="width: 50px"></th>
                        <th class="fw-bold fs-5" style="width: 50px"></th>
                        <th class="fw-bold fs-5" style="width: 50px"></th>

                        <!-- <th style="width: 50px">&nbsp;</th> -->
                      </tr>
                    </thead>
                    <!-- <transition name="drawerdown"> -->
                    <tbody name="list border-0" v-if="!sorting && rows?.length > 0">
                      <tr
                        v-for="row in rows"
                        :key="row.Id"
                        :class="
                          (
                            (selectedCase === row ? selectedCase === row : row.Id == 1) || this.caseId == row.Id
                              ? true
                              : false
                          )
                            ? 'selected'
                            : ' selectable'
                        "
                      >
                        <td
                          @click="openDropdown = null"
                          v-for="(col, i) in columns"
                          :key="col.id"
                          class="fs-5 fw-normal p-3"
                          :class="i == 0 ? 'pl-5' : ''"
                        >
                          <!-- <router-link class="primary-font" :to="`/Cases/${row.Id}`"> -->
                          <span
                            class="fs-5"
                            v-if="
                              col.name != 'photo' &&
                              col.name != 'caseAgeDesc' &&
                              col.name != 'Created' &&
                              col.name != 'CaseStatus'
                            "
                            >{{ row[col.name] }}
                          </span>
                          <!-- <div v-else style="width: 50px" class="p-0 m-0 pl-3 ml-0">
                        <img :src="row[col.name]"  class="rounded-circle img border-success shadow-lg float-right" style="height:50px;width:50px;">
                      </div> -->
                          <span class="fs-5" v-if="col.name == 'CaseStatus'">{{
                            ["Open", "Closed", "Bench Warrant"][row[col.name]]
                          }}</span>
                          <div v-if="col.name == 'Created'" class="p-0 m-0 pl-3 ml-0">
                            {{ dt.utc(row[col.name]).format("MM/DD/YYYY") }}
                          </div>
                        </td>
                        <td v-if="!loading" class="p-3">
                          <router-link :to="`/Cases/${row.Id}`">
                            <button class="btn btn-primary btn-xl fs-5" @click="selectCase(row, true)">View</button>
                          </router-link>
                          <!-- This is the scenarios option drop down -->
                          <!-- <div class="dropdown-wrapper" :class="{ open: openDropdown === row.Id }" @click.stop>
                          <button type="button" class="btn btn-primary btn-xl fs-5 d-flex align-items-center" @click="selectCase(row)">
                            View
                            <i v-if="caseStore.scenariosByParentId(row.Id).length" class="fa ms-2 pl-2" :class="openDropdown === row.Id ? 'fa-caret-up' : 'fa-caret-down'"></i>
                          </button>

                            <ul v-if="openDropdown === row.Id" class="menu">
                              <p class="fw-bold fs-4" style="padding-left: 10px">Scenarios</p>
                              <li class="menu-option d-block" @click="selectCase(row, true)">Original Case</li>
                              <li
                                class="menu-option d-block"
                                v-for="scenario in caseStore.scenariosByParentId(row.Id)"
                                :key="scenario.Id"
                                @click="selectCase(scenario)"
                              >
                                <!-- <router-link :to="`/Cases/${scenario.Id}`" @click.native.stop="caseStore.selectedCaseId = scenario.Id; openDropdown = null"> -->
                          <!-- {{ scenario.ScenarioName }} -->
                          <!-- </router-link> -->
                          <!-- </li> -->
                          <!-- </ul> -->
                          <!-- </div> -->
                        </td>

                        <td v-if="loading == false">
                          <button @click="toggleEditCase(row)" class="btn btn-primary-outline btn-xl">
                            <i class="fa fa-pencil"></i>
                          </button>
                        </td>
                        <td v-if="loading == false">
                          <button
                            @click="
                              caseToDelete = row;
                              deleteCaseModal = true;
                            "
                            class="btn btn-primary-outline btn-xl"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </td>

                        <!-- <td class="text-center">
                      <a class="btn btn-primary pi-draggable" id="case1btn" @click="selectCase">
                        <i class="fa fa-binoculars"> </i>
                      </a>
                    </td> -->

                        <!-- <td>Doe</td>
                    <td>John</td>
                    <td style="width: 50px">XYZ-123</td>
                    <td>211 - Robbery - 2nd Degree</td>
                    <td>Open</td>
                    <td class="text-center">
                      <a class="btn btn-primary pi-draggable" id="case1btn"
                        ><i class="fa fa-binoculars"></i
                      ></a>
                    </td> -->
                      </tr>
                    </tbody>
                    <tbody v-else-if="rows?.length == 0 && casestatus?.length !== 0">
                      <tr>
                        <td colspan="11" class="fs-5" style="text-align: center">
                          <br />
                          <button class="btn btn-primary btn-xl fs-5 ml-5 my-5" @click="popup = 'New Case'">
                            Add New Case<i class="fa fa-plus pl-5"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else-if="casestatus?.length == 0">
                      <tr>
                        <td colspan="11" class="fs-3" style="text-align: center">You have no filters selected</td>
                      </tr>
                    </tbody>
                    <!-- </transition> -->
                    <!-- <tfoot class="thead-light"></tfoot> -->
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- elsse -->
    </main>
  </div>
</template>

<script>
import fetch from "node-fetch";
import moment from "moment";
import NewCase from "./NewCase.vue";
import CaseDetails from "./CaseDetails.vue";
import axios from "axios";
import Modal from "../../components/utils/Modal.vue";
import AdPopUpModal from "../../components/utils/AdPopUpModal.vue";
import PostLoginHeader from "../Authentication/PostLoginHeader.vue";
import Scenarios from "./ControlPanel/ScenariosOld.vue";
import { RouterLink } from "vue-router";
import { useCrimeStore } from "../../stores/CrimeStore";
import { useCaseStore } from "../../stores/CaseStore";
import { handleError } from "../../helpers";
export default {
  name: "Cases",
  components: { NewCase, CaseDetails, Modal, PostLoginHeader, RouterLink, AdPopUpModal, Scenarios }, // do not forget this line on the parent component
  // props: ["app_token", "app_attr"],
  data() {
    return {
      app_token: null,
      // app_attr: null,
      crimeStore: useCrimeStore(),
      caseStore: useCaseStore(),
      data: "",
      columns: [
        // { name: "photo", text: "Photo" },
        { name: "DefendantLastName", text: "Last Name" },
        { name: "DefendantFirstName", text: "First Name" },
        { name: "DefendantMiddleName", text: "First Name" },
        { name: "CaseNumber", text: "Case Number" },
        // { name: "statuteDefinitionSection", text: "Section" },
        // { name: "Name", text: "Primary Charge" },
        { name: "Created", text: "Created" },
        { name: "CaseStatus", text: "Case Status" },
        // { name: "caseAgeDesc", text: "Case Age" },
      ],
      dt: moment,
      cases: [],
      rows: [],
      // selectedCase: null,
      casestatus: [0, 1, 2],
      page: 0,
      pages: 0,
      showSearchPanelFlag: false,
      search: "",
      awaitingSearch: false,
      lastname: "%",
      firstname: "%",
      casenumber: "%",
      priorpage_link: "",
      nextpage_link: "",
      pagebuttons: {},
      showNewCaseForm: false,
      showCaseDetails: false,
      showCaseList: true,
      caseId: 0,
      launchCrimesLookup: false,
      sorting: false,
      sortedBy: "Created",
      popup: null,
      selectNewestCase: false,
      deleteCaseModal: false,
      showAdPopUpModal: false,
      caseToDelete: null,
      selectedScenario: null,
      openDropdown: null,
      //Welcome message for first time users
      firstLoginMessage: null,
      organizationSettings: {},
      imageUrl: null,
      vhtmlContent: null,
      adType: null,
      adCode: null,
      userObj: null,
    };
  },

  watch: {
    search: function (newSearch, oldSearch) {
      this.filterCases();
    },
    // selectedScenario: function (newScenario, oldScenario) {
    //   window.location.href = `/Cases/${newScenario}`;
    // },
  },
  computed: {
    selectedCase() {
      return this.caseStore.selectedCase;
    },
  },
  methods: {
    async deleteAdPopUp() {
      const userId = JSON.parse(localStorage.getItem("user_attr"))?.id;
      try {
        await axios.delete(`${process.env.VUE_APP_ENDPOINT}/api/JWTUser/turnOffAdForUser`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        });
      } catch (err) {
        console.error("Error turning off ad:", err);
      } finally {
        this.showAdPopUpModal = false;
      }
    },

    async loadProbationData() {
      this.ProbationLimitations = await axios
        .get(process.env.VUE_APP_ENDPOINT + "/api/probationLimitations", {
          headers: { Authorization: `Bearer ` + this.app_token },
        })
        .then((data) => {
          return data.data
            .filter((pl) => pl.LegacyStatuteText != "*CATEGORIES*" && pl.Category != "FACTOR" && pl.EndDate == null)
            .sort((a, b) => a.SortOrder - b.SortOrder);
        })
        .catch((error) => {
          console.error(error);
        });
      // console.log(this.ProbationLimitations);
      this.ProbationFactors = await axios
        .get(process.env.VUE_APP_ENDPOINT + "/api/probationFactors", {
          headers: { Authorization: `Bearer ` + this.app_token },
        })
        .then((data) => {
          return data.data ?? [];
        })
        .catch((error) => {
          console.error(error);
          return [];
        });
      this.CaseProbationLimitations = await axios
        .get(process.env.VUE_APP_ENDPOINT + "/api/caseProbationLimitationStatus/" + this.currentCase.Id, {
          headers: { Authorization: `Bearer ` + this.app_token },
        })
        .then((data) => {
          return data.data ?? [];
        })
        .catch((error) => {
          console.error(error);
        });
      this.CaseProbationFactors = await axios
        .get(process.env.VUE_APP_ENDPOINT + "/api/caseProbationFactors/byCase/" + this.currentCase.Id, {
          headers: { Authorization: `Bearer ` + this.app_token },
        })
        .then((data) => {
          return data.data ?? [];
        })
        .catch((error) => {
          console.error(error);
        });
      this.charges.data.forEach((chg) => {
        if (chg.ProbationLimitationId !== null && this.ProbationLimitations.length > 0) {
          let probLimit = this.ProbationLimitations.findIndex((pl) => pl.Id == chg.ProbationLimitationId);
          if (probLimit !== -1) {
            chg.ProbationLimitationLawText = this.ProbationLimitations[probLimit].LawText;
          }
        }
      });
      return {
        ProbationLimitations: this.ProbationLimitations,
        ProbationFactors: this.ProbationFactors,
        CaseProbationLimitations: this.CaseProbationLimitations,
        CaseProbationFactors: this.CaseProbationFactors,
      };
    },

    async loadcaseCircumstances() {
      const caseCircumstances = await axios
        .get(process.env.VUE_APP_ENDPOINT + "/api/caseCircumstances/byCase/" + this.selectedCase.Id, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        })
        .then((res) => res.data)
        .catch((e) => console.log(e));
      return caseCircumstances;
    },

    handleCreateCase() {
      // Check if any of the organizationSettings fields are false
      const { DefendantDOB, DefendantLastName, DefendantMiddleName, DefendantFirstName } = this.organizationSettings;

      if (!DefendantDOB && !DefendantLastName && !DefendantMiddleName && !DefendantFirstName) {
        // If all the necessary fields are false, save the case directly
        this.saveNewCase(new Event("click"));
      } else {
        // Otherwise, open the New Case popup
        this.popup = "New Case";
      }
    },

    saveNewCase(e) {
      e.preventDefault();
      let token = this.app_token;
      let isValid = true;
      this.showErrors = false;

      const body = this.newCase;

      axios
        .post(process.env.VUE_APP_ENDPOINT + "/api/cases", body, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((res) => {
          if (res.status === 200 || res.status === 201) {
            window.location.href = `/Cases/${res.data.Id}`;
          }
        })
        .catch(handleError);
    },

    toggleEditCase(selectedCase) {
      this.selectedCase = selectedCase;
      this.caseStore.selectedCaseId = selectedCase.Id;
      this.popup = "Edit Case";
    },

    showCaseListPanelOrigin() {
      this.showCaseList = true;
      this.loadCases();
    },

    isValidName(str) {
      var re = /^[A-Za-z]+$/;
      if (re.test(str)) return true;
      else return false;
    },

    pagenav_click(uri, e) {
      // console.log(e.srcElement.id);
      let link = "";

      if (!uri) {
        if (e.srcElement.id == "next_button") link = this.nextpage_link;
        else if (e.srcElement.id == "prior_button") link = this.priorpage_link;
      } else {
        link = uri;
      }

      // console.log("link::::", link);

      if (link != "") {
        this.data.uri = process.env.VUE_APP_ENDPOINT + link;
        //let data = {"firstname":"%","lastname":"%","casenumber":"%", "uri":uri};
        let data = this.data;
        this.loadCases(data);
      }
    },

    setStatus(e) {
      let caseVal = -1;

      if (e.target.id == "caseOpen") caseVal = 0;
      if (e.target.id == "caseClose") caseVal = 1;
      if (e.target.id == "caseBW") caseVal = 2;
      // console.log(this.casestatus);
      if (caseVal > -1) {
        if (e.target.checked == true) {
          this.casestatus.push(caseVal);
        } else {
          for (var i = 0; i < this.casestatus.length; i++) {
            if (this.casestatus[i] === caseVal) {
              this.casestatus.splice(i, 1);
              i--;
            }
          }
        }
      }
      // if (this.casestatus?.length === 0) {
      //   this.casestatus.push(0);
      // }
      // console.log("caseVal", caseVal, "..... setStatus event:", this.casestatus);

      this.data.CaseStatus = this.casestatus;
      let data = this.data;
      this.loadCases(data);

      //casestatus
    },

    newCaseNewDefendant() {
      this.showNewCaseForm = true;
      this.showCaseDetails = false;
    },

    newCaseExistingDefendant() {
      this.showNewCaseForm = true;
      this.showCaseDetails = false;
    },

    closeNewCase(val) {
      this.showNewCaseForm = false;
    },

    closeCaseDetails() {
      this.showCaseDetails = false;
    },

    selectCase(r, force) {
      let scenarios = this.caseStore.scenariosByParentId(r.Id);
      if (scenarios.length > 0 && !force) {
        this.openDropdown = r.Id;
      } else {
        this.caseStore.selectedCaseId = r.Id;
        this.$router.push(`/Cases/${r.Id}`);
      }
      // //this.showCaseDetails = false;
      // this.showCaseList = false;
      // this.caseStore.selectedCase = r;
      // console.log("Selected Case . . . .", this.selectedCase, this.selectedCase.Id);
      // //
      // this.launchCrimesLookup = launchCrimesLookup;
      // this.showCaseDetails = true;
      // localStorage.setItem("selected_case", this.selectedCase);
      // localStorage.setItem("selected_case_id", this.selectedCase.Id);
    },

    savedNewCase(closeWindow, selectCase) {
      // console.log("here here here");
      // this.fetchResults({ query: "%" });
      // this.getDelayedData();

      // this.fetchResults({ query: "" });
      // this.popup = null;
      // console.log("savedNewCase:", this.rows[0]);
      // this.selectCase(this.rows[0], true);
      this.loadCases(selectCase);
    },

    // sleep(ms) {
    //   return new Promise((resolve) => setTimeout(resolve, ms));
    // },

    async getDelayedData() {
      this.fetchResults({ query: "" });
      // await this.sleep(1000);
      this.showNewCaseForm = false;
      // await this.sleep(1000);
      this.caseStore.selectedCaseId = this.rows[0]?.Id;
      // await this.sleep(1000);
      this.showCaseDetails = true;
    },

    sort(sortMethod) {
      // this.sorting = false
      // console.table(this.rows)

      if (this.sortedBy == sortMethod) {
        this.rows.reverse();
      } else {
        if (this.rows?.length > 0) {
          switch (sortMethod) {
            case "LastName":
              // console.log("SORTS BY LAST NAME");
              this.rows = this.rows.sort((a, b) => {
                // console.log(a.DefendantLastName, b.DefendantLastName)
                if (a.DefendantLastName > b.DefendantLastName) {
                  return 1;
                } else if (a.DefendantLastName < b.DefendantLastName) {
                  return -1;
                }
                return 0;
              });
              break;
            case "FirstName":
              // console.log("SORTS BY FIRST NAME");
              this.rows = this.rows.sort((a, b) => {
                // console.log(a.DefendantFirstName, b.DefendantFirstName)
                if (a.DefendantFirstName > b.DefendantFirstName) {
                  return 1;
                } else if (a.DefendantFirstName < b.DefendantFirstName) {
                  return -1;
                }
                return 0;
              });
              break;
            case "MiddleName":
              // console.log("SORTS BY MIDDLE NAME");
              this.rows = this.rows.sort((a, b) => {
                // console.log(a.DefendantMiddleName, b.DefendantMiddleName)
                if (a.DefendantMiddleName > b.DefendantMiddleName) {
                  return 1;
                } else if (a.DefendantMiddleName < b.DefendantMiddleName) {
                  return -1;
                }
                return 0;
              });
              break;
            case "Case#":
              // console.log(this.rows);
              this.rows = this.rows.sort((a, b) => {
                return b.CaseNumber - a.CaseNumber;
              });
              break;
            case "Created":
              this.rows = this.rows.sort((a, b) => {
                return new Date(b.CreatedAt) - new Date(a.CreatedAt);
              });
            case "Status":
              this.rows = this.rows.sort((a, b) => {
                return a.CaseStatus - b.CaseStatus;
              });
          }
        }
        this.sortedBy = sortMethod;
      }
      // this.sorting = true
      // console.table(this.rows)
    },

    loadNow(goToTopCase, closePopup, selectCase) {
      this.popup = null;
      this.showNewCaseForm = false;
      this.caseId = selectCase ? localStorage.getItem("selected_case_id") : null;

      //this.showCaseDetails = true;
      this.loadCases(goToTopCase);

      // console.log(process.env.VUE_APP_ENDPOINT);
      // console.log("loadNow(); APP_ATTR", this.app_attr);

      //const found = array1.find(element => element > 10);
    },

    async deleteCase(caseId) {
      const token = localStorage.getItem("user_token");
      this.caseStore.deleteCase(caseId);
      this.rows = this.caseStore.cases;
      this.deleteCaseModal = false;
      const foundIndex = this.rows.findIndex((c) => c.Id == caseId);
      if (foundIndex == -1) {
        return;
      }
      this.rows.splice(foundIndex, 1);
    },

    filterCases() {
      const filteredCaseArr = this.cases.filter((row) => {
        return (
          (row.DefendantLastName.toLowerCase().includes(this.search.toLowerCase()) ||
            row.CaseNumber.toString().includes(this.search)) &&
          !row.ParentCaseId
        );
      });
      this.rows = filteredCaseArr;
    },

    async updateFirstLoginMessage() {
      try {
        const response = await axios
          .post(`${process.env.VUE_APP_ENDPOINT}/api/subscriber/updateFirstLoginMessage`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("user_token"),
            },
          })
          .then((data) => {
            this.firstLoginMessage = true;
          })
          .catch(handleError);
      } catch (error) {
        console.error("Error updating first login message:", error);
      }
    },

    async fetchOrganizationSettings() {
      // const user_atr = JSON.parse(localStorage.getItem("user_attr"));
      // if (user_atr?.Subscriber?.SubscriptionType !== 3) {
      //   return;
      // }
      const response = await axios
        .get(process.env.VUE_APP_ENDPOINT + "/api/org/fetchOrganizationSettings", {
          headers: {
            Authorization: `Bearer ` + localStorage.getItem("user_token"),
          },
        })
        .catch(handleError);
      // this.subscriberObj = response?.data?.user_attr?.Subscriber;
      this.userObj = response?.data?.user_attr;
      this.organizationSettings = response.data?.organizationSettings;
      await this.loadUserSpecificAds();
    },

    async fetchUserAndSubscriberData() {
      // this.loading = true;
      this.token = localStorage.getItem("user_token");
      if (this.token?.length == 0) {
        window.location.href = "/login";
      }

      let response = await axios
        .post(
          `${process.env.VUE_APP_ENDPOINT}/api/auth/checkcredentials`,
          {
            user_token: this.token,
            source: "fetchUserAndSubscriberDataCases",
          },
          {
            headers: { Authorization: `Bearer ${this.token}` },
          }
        )
        .catch(handleError);

      // Extracting user and subscriber data
      // let subscriber;
      // let user;
      // if (response?.data?.user_attr) {
      //   this.subscriber = response?.data?.user_attr;
      //   user = response?.data?.user_attr;
      //   subscriber = this.subscriber?.Subscriber;
      // } else {
      //   this.subscriber = response?.data;
      //   user = response?.data;
      //   subscriber = this.subscriber?.Subscriber;
      // }

      // this.userObj = user;

      // this.firstLoginMessage = response?.data?.user_attr?.firstLoginMessage;

      // If firstLoginMessage is 0 (false), update it to 1 (true)
      //not being used yet
      if (this.firstLoginMessage === 0) {
        await this.updateFirstLoginMessage();
      }

      // this.loading = false;
      // console.log('First Login Message: ', this.firstLoginMessage);
    },

    onViewClick(row) {
      const id = row.Id;
      const hasScenarios = this.caseStore.scenariosByParentId(id).length > 0;

      if (hasScenarios) {
        if (this.openDropdown === id) {
          this.openDropdown = null;
        } else {
          this.openDropdown = id;
        }
      } else {
        this.caseStore.selectedCaseId = id;
        this.$router.push(`/Cases/${id}`);
      }
    },
    async fetchAdById(adId) {
      // console.log("Fetching ad with ID:", adId);
      try {
        const response = await axios.get(process.env.VUE_APP_ENDPOINT + `/api/AdPopUps/${adId}`, {
          headers: {
            Authorization: `Bearer ` + localStorage.getItem("user_token"),
          },
        });
        if (response && response.data.IsActive) {
          this.showAdPopUpModal = true;
          this.imageUrl = response.data.ImageUrl;
          this.vhtmlContent = response.data.VHtmlContent;
          this.adCode = response.data.AdCode;
          this.adType = response.data.AdType;
          // console.log("response: ", response);
          // console.log("all values: ", this.adCode, this.vhtmlContent, this.imageUrl, this.adId);
        }
      } catch (err) {
        console.error("Error fetching ad:", err);
      }
    },

    async loadUserSpecificAds() {
      const adId = this.userObj?.AdPopUpId;

      if (!adId) {
        // console.log("No ad assigned to this user");
        return;
      }

      await this.fetchAdById(adId);
    },

    hasScenarios(caseId) {
      return this.caseStore.cases.some((c) => c.ParentCaseId === caseId);
    },

    async loadCases() {
      await this.caseStore.loadCases(true);
      this.cases = this.caseStore.cases;
      this.scenarios = this.cases.filter((c) => c.ParentCaseId != null);
      this.filterCases();
      this.sort("Created");
      this.loading = false;
      return;
    },
  },

  async beforeMount() {
    this.loading = true;
    this.app_token = localStorage.getItem("user_token");
    // document.addEventListener("click", this.handleOutsideClick);

    this.loadCases();
    this.crimeStore.loadCrimes();

    this.fetchOrganizationSettings();

    // this.loadNow();
    // this.crimeStore.loadCrimes();
  },
};
</script>

<style scoped>
.ad-popup-content {
  min-width: 400px;
}

.ad-popup-content img {
  max-width: 100%;
}

.menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000000;
  background-color: var(--primary);
  border: 1px solid var(--primary-font);
  padding: 10px;
  border-radius: 20px;
  list-style: none;

  min-width: 100%;
  max-width: 100vw;

  width: 10rem;
  max-height: 20rem;
  overflow-y: auto;

  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.menu li {
  margin: 0;
  /* padding: 0;
  list-style: none; */
}

.menu-option {
  display: block;
  width: 100%;
  box-sizing: border-box;
  /* padding: 10px; */
  color: var(--primary-font);
  /* border-bottom: 1px solid var(--primary-font); */
  font-weight: 400;
}

.menu-option:hover {
  background-color: var(--off-blue);
  color: var(--primary-font);
  cursor: pointer;
  text-decoration: none;
  /* border-radius: 10px; */
}

.menu-option-name {
  padding: 10px;
}

.dropdown-wrapper {
  position: relative;
  display: inline-block;
  overflow: visible;
}
.dropdown-wrapper .menu {
  display: none;
}

.dropdown-wrapper.open .menu {
  display: block;
}

.menu-icon {
  background-color: #ccc;
  border-radius: 100px;
  padding: 5px;
  border: 2.5px solid #bbb;
}

.menu-icon:hover {
  background-color: var(--off-blue) !important;
  border-color: var(--primary-font) !important;
}

.menu-option {
  display: block;
  padding: 10px;
  color: var(--primary-font);
  font-weight: 400;
}

.menu-option:hover {
  background-color: var(--off-blue);
  border-radius: 10px;
}

.menu-option-name {
  padding: 10px;
}

.img {
  display: block;
  max-width: 230px;
  max-height: 85px;
  width: auto;
  height: auto;
  filter: grayscale(0.95) brightness(1.5);
}

.case-popup {
  max-width: 20vw !important;
}

@media (max-width: 800px) {
  .case-popup {
    max-width: 90vw !important;
  }
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.no-hover:hover {
  cursor: default !important;
}
</style>
